/* comptes à rebours jusqu'à la clôture des précommandes (leur date : 31.10, minuit).
   Chargé AVANT les bibliothèques : aucun chiffre n'est écrit dans le HTML, sinon il se fige à la date
   où on l'a tapé (27 J le 05.10) et s'affiche le temps que le reste arrive, ou chez qui lit la page sans script. */
(function(){
  const cds=document.querySelectorAll('.cd[data-fin]');
  if(!cds.length)return;
  const p2=n=>String(n).padStart(2,'0');
  /* data-maillot : les jours en numéros de maillot Maison Piège, le reste en texte.
     Les images ne changent qu'avec le jour, pas à chaque seconde. */
  const L={0:302,1:182,2:284,3:302,4:340,5:288,6:298,7:282,8:308,9:296};
  const maillot=(el,j,h,m,s)=>{
    if(!el._j){el.innerHTML='<span class="cd-j num" aria-hidden="true"></span><span class="cd-r"><i></i><span></span></span>';
      el._j=el.firstChild;el._u=el.lastChild.firstChild;el._r=el.lastChild.lastChild}
    if(el._jv!==j){el._jv=j;el._u.textContent=j===1?'JOUR':'JOURS';
      el._j.innerHTML=p2(j).split('').map(c=>`<img src="${MP_ASSETS['img/marque/chiffres/'+c+'.png']}" alt="" width="${L[c]}" height="720">`).join('')}
    el._r.textContent=`${p2(h)} H ${p2(m)} MIN ${p2(s)} S`;
    el.setAttribute('aria-label',`${j} jours, ${h} heures, ${m} minutes`)};
  const tic=()=>cds.forEach(el=>{
    const r=Math.max(0,new Date(el.dataset.fin)-Date.now());
    if(!r){el._j=null;el.textContent='PRÉCOMMANDES CLOSES';return}
    const j=Math.floor(r/864e5),h=Math.floor(r/36e5)%24,m=Math.floor(r/6e4)%60,s=Math.floor(r/1e3)%60;
    if('maillot' in el.dataset)return maillot(el,j,h,m,s);
    el.textContent=`${j} J ${p2(h)} H ${p2(m)} MIN ${p2(s)} S`});
  tic();setInterval(tic,1000);
})();
